import styled from "styled-components";
import LifeAtModal from "@common/LifeAtModal/LifeAtModal";
import { LifeAtBodyPrimary, LifeAtBodySecondary } from "@common/LifeAtText/LifeAtText";

export const RoomModal = styled(LifeAtModal)`
    .lifeat-modal {
        max-height: 80%;
        overflow-y: scroll;

        ::-webkit-scrollbar-thumb {
            display: block;
            border-radius: 4px;
            background-color: ${(props) => props.theme.textColorSecondary};
            border: 3px ${(props) => props.theme.backgroundPrimary} solid;
        }

        ::-webkit-scrollbar {
            display: block;
            width: 11px;
        }
    }

    .modal-content > * {
        margin-bottom: unset;
    }
`;

export const RoomSettingLabelPrimary = styled(LifeAtBodyPrimary)<{ isDisabled?: boolean }>`
    display: flex;
    opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
`;

export const RoomSettingLabelSecondary = styled(LifeAtBodySecondary)`
    margin: 4px 0;
`;

export const SettingsDivider = styled.span`
    width: 100%;
    height: 1px;
    border-bottom: 1px solid ${(props) => props.theme.borderPrimary};
    margin-bottom: 15px;
`;
